import React from 'react';

const Logo = ({ size = 'md', className = '' }) => {
  const sizes = {
    xs: 160,
    sm: 160,
    md: 160,
    lg: 160,
    xl: 160,
  };

  const img = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center ${className}`} data-testid="logo">
      <img
        src="/images/tradereflex_logo.png"
        alt="TradeReflex"
        className="object-contain"
        style={{ width: img, height: 'auto', maxHeight: 40 }}
      />
    </div>
  );
};

export default Logo;
